import React, { Component } from 'react';
import { Upload, message, DatePicker, Button, Icon } from 'antd';
import moment from "moment";

const { MonthPicker } = DatePicker;

class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        loading: false,
        fileList: []
    }
    render() {
        const { date, loading, fileList } = this.state;
        const that = this;
        const props = {
            name: 'file',
            action: '/priceExcel',
            accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            headers: {
                authorization: 'authorization-text',
            },
            data: {
                month: moment(date).format('M'),
                year: moment(date).format('YYYY'),
            },
            fileList,
            onChange(info) {
                that.setState({ fileList: [info.file], loading: true });
                if (info.file.status === 'done') {
                    if (info.file.response.status == 1) {
                        message.success(`${date} 数据已经更新成功！`);
                    } else {
                        message.error(`${date} 更新失败，请重新上传或联系管理员！`);
                    }
                    that.setState({ loading: false, });
                    return
                } else if (info.file.status === 'error') {
                    message.error(`表格上传失败！`);
                    that.setState({ loading: false, });
                }
            },
        };
        return (
            <div className="excel-upload">
                <div className="list">
                    <div className="title">
                        1.3 Price Repairing File Upload 官网比价文件上传
                </div>
                    <MonthPicker
                        placeholder="请选择年月"
                        monthCellContentRender={(date, local) => {
                            return moment(date).format('M月')
                        }}
                        defaultValue={moment(this.state.date, "YYYY-MM")}
                        format="YYYY-MM"
                        onChange={(date, str) => {
                            this.setState({ date: str });
                        }}
                    />
                    <Upload {...props}>
                        <Button
                            loading={loading}
                        >
                            <Icon type="upload" /> {loading ? '文件上传中。。。' : "本地上传"}
                        </Button>
                    </Upload>
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/price/1.3/index.js